module.exports = __webpack_public_path__ + "static/media/ETH-DAI.407c28ea.png";